import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api.js';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { Paper } from '@mui/material';

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await api.post('/users/login', formData);
      const { token, user } = response.data.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      navigate('/');
    } catch (err) {
      showError(err.response?.data?.message || 'Algo de errado aconteceu.');
    } finally {
      setLoading(false);
    }
  };

  const showError = (message) => {
    const alert = <Alert
      className="error-content"
      variant="outlined"
      severity="error"
    >
      {message}
    </Alert>;
    setError(alert);
    setTimeout(() => setError(null), 3000);
  };

  return (
    <div className="w-100 h-100 align-center justify-center">
      {error}
      <Paper className="container-login">
        <h1 className="mt-0">Login</h1>
        <TextField
          sx={{ width: '300px' }}
          size="small"
          id="username"
          name="username"
          label="Usuário"
          variant="outlined"
          onChange={handleChange}
        />
        <FormControl sx={{ width: '300px' }} variant="outlined">
          <InputLabel
            name="password"
            size="small"
            htmlFor="outlined-adornment-password"
            onChange={handleChange}
          >
            Senha
          </InputLabel>
          <OutlinedInput
            label="Senha"
            size="small"
            name="password"
            id="outlined-adornment-password"
            onChange={handleChange}
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  title={
                    showPassword ? 'Ocultar senha' : 'Mostrar senha'
                  }
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <Button
          sx={{ width: '300px', height: '40px' }}
          variant="outlined"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          { loading ? <CircularProgress size={20} /> : 'Entrar' }
        </Button>
      </Paper>
    </div>
  );
}

export default Login;
